import React from 'react';

/**
 * 
 */
export default class ShoppingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { secondsElapsed: 0 };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <div className="shopping-list"> 
        <h1>Shopping List for {this.props.name}</h1> 
        <ul> 
          <li>Instagram</li> 
          <li>WhatsApp</li> 
          <li>Oculus</li> 
        </ul> 
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/ShoppingList.js